// Our kanchaneshver.com servers run only Mon–Sat, 10:00 AM – 7:30 PM (IST).
// Outside these hours, links to those servers are sent to the Hostinger-hosted
// MyRinBazaar site, which captures basic details until the servers are back.

export const OFFLINE_FALLBACK_URL = 'https://myrinbazaar.com/';

const SERVER_OPEN_MINUTES = 10 * 60;        // 10:00 AM
const SERVER_CLOSE_MINUTES = 19 * 60 + 30;  // 7:30 PM
const SERVER_DAYS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

const istFormatter = new Intl.DateTimeFormat('en-US', {
    timeZone: 'Asia/Kolkata',
    weekday: 'short',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
});

export const isServerOnline = (date = new Date()) => {
    const parts = Object.fromEntries(
        istFormatter.formatToParts(date).map(({ type, value }) => [type, value])
    );
    const minutes = Number(parts.hour) * 60 + Number(parts.minute);

    return SERVER_DAYS.includes(parts.weekday)
        && minutes >= SERVER_OPEN_MINUTES
        && minutes < SERVER_CLOSE_MINUTES;
};

const isOnOurServer = (url) => {
    try {
        const { hostname } = new URL(url);
        return hostname === 'kanchaneshver.com' || hostname.endsWith('.kanchaneshver.com');
    } catch {
        return false;
    }
};

// Returns the given URL during server hours, otherwise the MyRinBazaar fallback.
export const getServerUrl = (url) =>
    isOnOurServer(url) && !isServerOnline() ? OFFLINE_FALLBACK_URL : url;

// MyRinBazaar adds ?from=myrinbazaar when it sends visitors here, and we add
// ?from=ksdpl when we send them there, so the two sites never bounce a visitor
// back and forth (e.g. if the visitor's device clock is wrong).
const OFFLINE_REDIRECT_URL = `${OFFLINE_FALLBACK_URL}?from=ksdpl`;
const CAME_FROM_MYRINBAZAAR = new URLSearchParams(window.location.search).get('from') === 'myrinbazaar';
const IS_LOCAL_DEV = ['localhost', '127.0.0.1'].includes(window.location.hostname);

const redirectIfServerOffline = () => {
    if (!CAME_FROM_MYRINBAZAAR && !IS_LOCAL_DEV && !isServerOnline()) {
        window.location.replace(OFFLINE_REDIRECT_URL);
    }
};

// Checks on load, then every minute so an open tab also moves at 7:30 PM.
export const watchServerHours = () => {
    redirectIfServerOffline();
    setInterval(redirectIfServerOffline, 60 * 1000);
};
